module.exports = __webpack_public_path__ + "static/img/loading-yellow.9f11d70.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/loading-yellow.gif
// module id = y5iM
// module chunks = 0